import React from 'react';
import { RadioButtonGroupInput, RadioButtonGroupInputProps } from 'react-admin';

const CHOICES = [{ id: 'true', name: 'Yes' }, { id: 'false', name: 'No' }];

type Props = Omit<RadioButtonGroupInputProps, 'choices' | 'parse' | 'format' | 'defaultValue'> & {
  defaultValue?: boolean;
};

const BooleanRadioGroupInput = ({ defaultValue, ...props }: Props) => (
  <RadioButtonGroupInput
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
    choices={CHOICES}
    parse={(value) => value === 'true'}
    format={(value: boolean) => (value ? 'true' : 'false')}
    defaultValue={defaultValue as any}
  />
);

export default BooleanRadioGroupInput;
